<template>
  <div class="stage-nav-box" @mouseenter.once="load_all_images">
    <ul class="stage-ul" ref="stageUl">
      <li class="bar"></li>
      <li
        class="stage-li"
        :class="[
          item.children && item.children.filter((i) => i.title).length > 0
            ? 'has-children'
            : '',
        ]"
        v-for="(item, key) in asideData"
        :key="item.slug"
      >
        <span
          class="title"
          @mouseenter="on_mouseenter($event, item.slug)"
          @mouseout="on_mouseout($event, item.slug)"
          @click="on_click($event, item.slug)"
          :class="[key === 0 ? 'active' : '']"
        >
          <span class="title-inside">{{ item.episode ? item.episode : item.title }}</span>
        </span>
        <div class="desc-box"></div>
        <template
          v-if="
            item.children && item.children.filter((i) => i.title).length > 0
          "
        >
          <ul class="stage-ul children">
            <li
              class="stage-li"
              v-for="_item in item.children.filter((i) => i.title)"
              :key="_item.slug"
            >
              <span
                class="title"
                @mouseenter="
                  on_mouseenter_children($event, item.slug, _item.slug)
                "
                @mouseout="on_mouseout_children($event, item.slug, _item.slug)"
                @click="on_click_children($event, item.slug, _item.slug)"
              >
                <span>title</span>
              </span>
              <div class="desc-box"></div>
            </li>
          </ul>
        </template>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { i18n } from "utils/util";
import ImagePreloader from "image-preloader";
import "./index.scss";

export default {
  computed: {
    ...mapState("global", ["schema"]),
    asideData() {
      return this.schema.global.item.aside.data;
    },
  },
  data() {
    this.isLoading = false;
    return {};
  },
  methods: {
    load_all_images() {
      let images = [];
      this.asideData.map((item) => {
        if (item.slug === "home") return;
        item.slug && images.push(i18n(`images/home/thumb/${item.slug}.jpg`));
        item.children?.map((_item) => {
          _item.slug &&
            images.push(
              i18n(`images/home/thumb/${item.slug}/${_item.slug}.jpg`)
            );
        });
      });

      new ImagePreloader().preload(images);
    },
    go(ev, slug) {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;
      let isLoaded = false;
      let $el = $(ev.currentTarget).parent();
      let { left: elLeft } = $el.offset();
      let { left: parentLeft } = $(this.$refs.stageUl).offset();
      let barLeft = elLeft - parentLeft;

      if (this.$P.isRtl) {
        barLeft =
          $(this.$refs.stageUl).outerWidth() -
          $el.position().left -
          $el.outerWidth();

        if ($el.parents(".has-children").length > 0) {
          barLeft =
            barLeft - $el.parents(".has-children").eq(0).position().left;
        }
      }

      let $bar = $(this.$refs.stageUl).find(".bar");
      let progress = 0;
      let timer = null;
      $el.children(".title").addClass("active");

      function progress_func() {
        if (progress < 95) {
          timer = setTimeout(function () {
            if (isLoaded) {
              return;
            }
            progress += 5;
            $bar.css("width", (progress / 100) * Math.max(0, barLeft));
            progress_func();
          }, Math.random() * 100 + 20);
        }
      }

      progress_func();

      this.$P.$once("route_before_change", () => {
        $bar.css("transition", "none");
        $bar.css("width", barLeft);
        isLoaded = true;
      });
      this.$router.push({ path: slug });
    },
    show_desc(ev, current) {
      let $desc = ev.currentTarget.querySelector(".desc-box");
      if (!$desc) {
        $desc = ev.currentTarget.parentNode.querySelector(".desc-box");
      }
      $($desc).css("opacity", 0);
      if ($desc.innerHTML.trim().length === 0) {
        let link = i18n(`images/home/thumb/${current.slug}.jpg`);
        $desc.innerHTML = `<div class="img-box"><img src="${link}" /></div><span>${this.$P.uni2zg(
          current.title
        )}</span>`;
      }
      $desc.offsetHeight;
      $($desc).css("opacity", 1);
    },
    hide_desc(ev) {
      let $desc = ev.currentTarget.querySelector(".desc-box");
      if (!$desc) {
        $desc = ev.currentTarget.parentNode.querySelector(".desc-box");
      }
      $($desc).css("opacity", 0);
    },
    on_mouseenter_children(ev, parentSlug, slug) {
      let parent = this.asideData.find((i) => i.slug === parentSlug);
      if (!parent) return;
      let current = parent.children.find((i) => i.slug === slug);
      if (!current) return;
      this.show_desc(ev, {
        slug: `${parentSlug}/${slug}`,
        title: current.title,
      });
    },
    on_mouseout_children(ev, parentSlug, slug) {
      this.hide_desc(ev);
    },
    on_mouseenter(ev, slug) {
      if (ev.currentTarget.classList.contains("active")) return;
      let current = this.asideData.find((i) => i.slug === slug);
      if (!current) return;
      this.show_desc(ev, current);
    },
    on_mouseout(ev, slug) {
      this.hide_desc(ev);
    },
    on_click(ev, slug) {
      if (ev.currentTarget.classList.contains("active")) return;
      this.go(ev, slug);
    },
    on_click_children(ev, parentSlug, slug) {
      this.go(ev, `${parentSlug}/${slug}`);
    },
  },
};
</script>
